import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface AllergyStatus {
  status: 'none' | 'medication' | 'other' | 'no-allergies';
  tooltip: string;
}

@Injectable({
  providedIn: 'root'
})
export class AllergyStatusService {
  private allergyStatusSubject = new BehaviorSubject<AllergyStatus>({
    status: 'none',
    tooltip: 'No se han registrado alergias'
  });

  allergyStatus$ = this.allergyStatusSubject.asObservable();

  updateAllergyStatus(status: AllergyStatus) {
    this.allergyStatusSubject.next(status);
  }

  getCurrentStatus(): AllergyStatus {
    return this.allergyStatusSubject.getValue();
  }
}
